import React, { useState, useEffect } from "react";
import {
  Box,
  Flex,
  Spacer,
  HStack,
  Text,
  useTheme,
  Spinner,
} from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import { useDisclosure } from "@chakra-ui/react";
import CourseTextButton from "../../../components/buttons/CoursesTextButton";
import SearchBox from "../../../components/searchbox/SearchBox";
import NumberInputLimit from "../../../components/numberInput/NumberInputLimit";
import AddAssignmentModal from "../../../components/modals/AddModals/AddAssignmentModal";
import AssignmentTable from "../../../components/table/assignmentTable/AssignmentTable";
import { getAllAssignment } from "../../../store/slice/assignmentSlice";
import { extractFileName } from "../../../utils/extractFileNameFromUrl";

const Assignment = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const { primaryBlue } = theme.colors.pallete;

  const { isOpen, onOpen, onClose } = useDisclosure();
  const { assignments, status } = useSelector((state) => state.assignments);

  const [searchTerm, setSearchTerm] = useState("");
  const [editData, setEditData] = useState(null);
  const [limit, setLimit] = useState(5);

  useEffect(() => {
    dispatch(getAllAssignment());
  }, [dispatch]);

  const handleEditAssignment = (id) => {
    const selectedAssignment = assignments.find((a) => a.id === id);
    if (selectedAssignment) {
      setEditData(selectedAssignment);
      onOpen();
    }
  };

  const filteredAssignments = assignments?.filter((a) =>
    a?.topicName?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const transformedAssignments = filteredAssignments?.map((item, index) => {
    const files =
      item?.assignmentFiles?.map((file) => ({
        url: file.key,
        name: extractFileName(file.key),
      })) || [];

    return {
      ...item,
      sno: index + 1,
      files,
    };
  });

  return (
    <Box p={5}>
      <Flex>
        <Text fontWeight={500} fontSize={"18px"} color={primaryBlue}>
          Assignment
        </Text>
        <Spacer />
        <CourseTextButton text={"Add Assignment"} onClick={onOpen} />
      </Flex>

      <Flex mt={"2%"}>
        <HStack spacing={4}>
          <Text fontSize={"14px"}>Show :</Text>
          <NumberInputLimit value={limit} onChange={setLimit} />
        </HStack>

        <Spacer />

        <SearchBox onSearch={setSearchTerm} />
      </Flex>

      {status === "loading" ? (
        <Flex justify="center" align="center" mt={10}>
          <Spinner size="lg" />
        </Flex>
      ) : (
        <AssignmentTable
          data={transformedAssignments}
          onEdit={handleEditAssignment}
          entityType="assignment"
          limit={limit}
        />
      )}

      <AddAssignmentModal
        isOpen={isOpen}
        onClose={() => {
          setEditData(null);
          onClose();
        }}
        editData={editData}
      />
    </Box>
  );
};

export default Assignment;
